import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

function IntegrationUserRenderer(props) {
  const { value, data } = props;
  if (!data || !data._id) {
    return null;
  }
  if (value === null) {
    return (<em className="text-muted">N/A</em>);
  }
  if (props.requestCheckUserPermission) {
    return (
      <Button onClick={() => { props.requestCheckUserPermission(data); }} bsSize="xs" bsStyle={value ? 'success' : 'default'}>{(value ? 'YES' : 'NO')}</Button>
    );
  }
  return (
    <span className={`label ${(value ? 'label-success' : 'label-danger')}`}>{(value ? 'YES' : 'NO')}</span>
  );
}

IntegrationUserRenderer.propTypes = {
  value: PropTypes.bool,
  data: PropTypes.shape({
    _id: PropTypes.string,
  }),
  requestCheckUserPermission: PropTypes.func,
};
IntegrationUserRenderer.defaultProps = {
  value: null,
  requestCheckUserPermission: null,
};

export default IntegrationUserRenderer;
